import { isNull, isNumber, isString } from 'lodash'

export const joinByComma = <T = string>(arr: T[]) => arr.filter((item) => item).join(', ')

export const hasMinLength = (text: string, searchMinLength: number) =>
	text.trim().length >= searchMinLength

export const getTextFromHTMLString = (tag: string): string => tag.replace(/(<([^>]+)>)/gi, '')

export const capitalize = (str: string): string =>
	!str ? str : str[0].toUpperCase() + str.substring(1).toLowerCase()

export const capitalizeString = (str: string | null | undefined): string => {
	if (!isString(str)) {
		return ''
	}

	return str.split(' ').map(capitalize).join(' ')
}

export const isEmptyString = (value: string | number | null): boolean => {
	if (isNull(value)) {
		return false
	}

	if (isNumber(value)) {
		return `${value}` === ''
	}

	return value === ''
}

export const retrieveHtmlTextAndLength = (data: string): { text: string; length: number } => {
	if (!data) {
		return { text: '', length: 0 }
	}

	const escapeCount = (data.match(/['"""''<>&]/g) || []).length
	const text = data
		.replace(/<[^>]+>/g, '')
		.replace(/&[^;]+;/g, ' ')
		.trim()

	return { text, length: data.length + escapeCount }
}

export const replaceNewLinesWithBr = (text: BasicString) => {
	if (text) {
		return text.replace(/\n/g, '<br>')
	}
	return text
}

export const sortByLabel = (a: LabelValue<number>, b: LabelValue<number>) => {
	if (a.label < b.label) {
		return -1
	}

	if (a.label > b.label) {
		return 1
	}
	return 0
}
